
/*hover on menu*/ 

$(function() {


  $('.firstlavel4').on('mouseenter',function() {

    $(this).attr('open', '');
  })
  $('.firstlavel4').on('mouseleave',function() {
    //      console.log('hiii');

    $(this).removeAttr("open","open");
  })


});

function CustomCart(abc,qty)
{
  var data = {
    "id": abc,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    async:false,
    dataType: 'json',
    success: function(){
      $('.addedCart').css('display','block');
      setTimeout(function(){ $('.addedCart').css('display','none'); }, 4000);
      this.cartNotification = document.querySelector('cart-notification');
      this.cartNotification.setActiveElement(document.activeElement);   
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), data })
      .then((response) => response.json())
      .then((parsedState) => {    
        
      })
      console.log(response);
    }
  });
}
$(document).ready(function(){
  $('body').on('click','.customAddCart',function(){
    var vId = $(this).attr('value');
    var qty = $(this).parent().parent().parent().children('.modal-quanity').children().children().children('input').val();
    CustomCart(vId,qty);
  });


  // MODAL // LK //
  $('.crossButton').on('click',function(){
    $('.modalMain').css('display','none');
  });
  $('.quickViewDiv').on('click',function(){
    var clickedID = $(this).attr('data-id');
    for(var i = 0 ; i < document.getElementsByClassName('modalMain').length ; i++)
    {
      if(clickedID == document.getElementsByClassName('modalMain')[i].getAttribute('data-product-id'))
      {
        var found = document.getElementsByClassName('modalMain')[i];
      }
    }
    found.style.display = 'block';
    console.log(found.firstElementChild.offsetHeight);
    if(found.firstElementChild.offsetHeight > 540)        
    {
      found.firstElementChild.lastElementChild.style.overflowY = 'scroll';
      found.firstElementChild.lastElementChild.style.height = ''+540+'px';
    }
  });
  $(window).scroll(function(){
    if($('product-recommendations .collection-hoverbtn .quickViewDiv').length > 0)
    {
      $('.crossButton').on('click',function(){
        $('.modalMain').css('display','none');
      });
      $('.quickViewDiv').on('click',function(){
        var clickedID = $(this).attr('data-id');
        for(var i = 0 ; i < document.getElementsByClassName('modalMain').length ; i++)
        {
          if(clickedID == document.getElementsByClassName('modalMain')[i].getAttribute('data-product-id'))
          {
            var found = document.getElementsByClassName('modalMain')[i];
          }
        }
        found.style.display = 'block';
      });
    } 
  });
});
///////////////////

////Read Less and Read More

function lessmore()
{
  var dot = document.getElementById("dots-lm");
  var moreText = document.getElementById("more-less");
  var btnText = document.getElementById("more-less-btn");
  if (dot.style.display === "none") 
  {
    dot.style.display = "inline";
    btnText.innerHTML = "Read More";
    moreText.style.display = "none";
  }
  else
  {
    dot.style.display = "none";
    btnText.innerHTML = "Read Less";
    moreText.style.display = "inline";
  }
}
//////////////////

/*=================== quick view modal product slider ======================*/

$('#detail .main-img-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  fade:true,
  autoplay: false,
  autoplaySpeed: 500,
  lazyLoad: 'ondemand',
  asNavFor: '.thumb-nav'
  //   prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
  //   nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'
});
// Thumbnail/alternates slider for product page
$('.thumb-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  centerPadding: '0px',
  asNavFor: '.main-img-slider',
  dots: false,
  centerMode: false,
  draggable: true,
  focusOnSelect: true
  //   prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
  //   nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'  
});


//keeps thumbnails active when changing main image, via mouse/touch drag/swipe
$('.main-img-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  $('.thumb-nav .slick-slide').removeClass('slick-current');
  $('.thumb-nav .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');  
});
//   $('#smallimg-row').slick({
//   infinite: true,
//   slidesToShow: 3,
//   arrows: true,
//   speed: 500,
//   autoplay:false,
//   slidesToScroll: 1
// });


//  $('.productimg').slick({
//   slidesToShow: 1,
//   slidesToScroll: 3,
//   arrows: false,
//     speed: 500,
//     dots: false,
//     asNavFor: '.small-img-row',
//     focusOnSelect: true
// });
// $('.small-img-row').slick({
//   slidesToShow: 3,
//     arrows: true,
//   slidesToScroll: 1,
//   speed: 500,
//   asNavFor: '.productimg',
//   dots: false,
//   centerMode: false,
//   focusOnSelect: true
// });

/*=================== end quick view modal ======================*/

// parikshat's edit 

$('.owl-carousel').owlCarousel({
  loop:true,
  margin:10,
  lazyLoad:true,
  nav:true,
  dots:false,
  responsive:{
    0:{
      items:1.3
    },
    600:{
      items:2
    },
    1000:{
      items:3
    }
  }
});
$(".owl-carousel").on("changed.owl.carousel",function(){
  var src = $(this).parents(".modalMain").find(".owl-item.active").eq(2).find("img").attr('src');
  console.log('Image current is ' + src);
  $(this).parents(".modalMain").find(".main-img img").attr("src", src);
});
$("body").on("click",".owl-item",function(){
  var src = $(this).find("img").attr('src');
  console.log('Image current is ' + src);
  $(this).parents(".modalMain").find(".main-img img").attr("src", src);
});

$(document).mouseup(function(e){
  var container = $(".modalMain .model-2");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) 
  {
    container.find(".close-modal").click();
  }
}); 